export default "__VITE_ASSET__DNJrYkeu__"